<template>
    <div class="Capacity">
        <div class="Capacity-dv">
            <div class="Capacity-dvh">
                <!-- <img src="../../assets/bg-chengzhang03.png" alt=""> -->
                <h1>能力预警记录</h1>
            </div>
        </div>
        <div class="Capacity-dv1">
            <ul>
                <li v-for="(item,index) in list" :key="index" >
                    <div class="biaoti">

                    </div>
                    <span v-if="item.term == 2">{{item.grade }}-{{item.grade+1}}学年 第二学期</span>
                    <span v-if="item.term == 1">{{item.grade }}-{{item.grade+1}}学年 第一学期</span>
                    <div class="arrowshang" v-if="item.showifon " @click.stop="openshang(item,index)">
                    </div>
                    <div class="arrowxia" v-else @click.stop="open(item,index)">

                    </div>
                    <transition name="hehe">
                        <div class="Capacity_content" v-if="item.showifon ">
                            <h3>能力达成反馈预警报告</h3>
                            <h2 v-if="item.term == 2">亲爱的{{userName}}，系统对您{{item.grade }}-{{item.grade+1}}学年 第二学期 结束后的能力达成情况进行分析后发现</h2>
                            <h2 v-if="item.term == 1">亲爱的{{userName}}，系统对您{{item.grade }}-{{item.grade+1}}学年 第一学期 结束后的能力达成情况进行分析后发现</h2>
                            <div class="Capacity_fan" v-if="item.obj.type1">
                                <div class="fan_ul" id="son">
                                    <div  class="fan_li">
                                       <div class="fan_dvfloat">
                                            <div class="icontongguo" v-if="item.obj.type1">

                                            </div>
                                            <span :class="{colorfont:item.obj.type1}">{{item.obj.type1}}</span>
                                       </div>
                                        <p v-if="item.obj.type1">{{item.obj.returnFeedback1}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="Capacity_fan"  v-if="item.obj.type2">
                                <div class="fan_ul" id="son">
                                    <div  class="fan_li">
                                        <div class="fan_dvfloat">
                                            <div class="iconzhuyi" v-if="item.obj.type2">

                                            </div>
                                            <span :class="{colorfont1:item.obj.type2}">{{item.obj.type2}}</span>
                                        </div>
                                        <p v-if="item.obj.type2">{{item.obj.returnFeedback2}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="Capacity_fan" v-if="item.obj.type3">
                                <div class="fan_ul" id="son">
                                    <div  class="fan_li">
                                        <div class="fan_dvfloat">
                                            <div class="iconyujing" v-if="item.obj.type3">

                                            </div>
                                            <span :class="{colorfont2:item.obj.type3,}">{{item.obj.type3}}</span>
                                        </div>
                                        <p v-if="item.obj.type3">{{item.obj.returnFeedback3}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </li>
            </ul>
        </div>
        <back-to :path="'/'"></back-to>
    </div>
</template>
<script>
import backTo from '@/components/back'
import api from "@/api"
export default {
    components: { backTo },
    data(){
        return{
            chart: null,
            isActive:0,
            userName:JSON.parse(localStorage.getItem('userInfo')).userName,
            type1:'',
            returnFeedback1:'',
            type2:'',
            returnFeedback2:'',
            type3:'',
            returnFeedback3:'',
            pointList:[], //柱状图数据
            list:[],
        }
    },
    methods:{
        open(item,index){
            const self=this
            self.$set(self.list[index], 'showifon', true)
            if(item.grade == null && item.term == null  ){
                this.$toast({
                    message: '暂时没有数据',
                    position: 'bottom'
                })
            }
            this.earlyWarning(item.grade,item.term,index)
        },
        openshang(item,index){
            const self=this
            self.$set(self.list[index], 'showifon', false)
        },
        getAllGradeRef1(){
            this.$get(api.questionnaire.getAllGradeRef()).then(res=>{
                if(res.status == 1){
                    res.data.yearTerm.forEach(item=>{
                        item.claims = res.data.claims
                        item.obj= {}
                        item.showifon = false
                    })
                    this.list = res.data.yearTerm
                    this.list.forEach(item=>{
                        item.gradeterm = `${item.grade}` + `${item.term}`
                    })
                }
            })
        },
        earlyWarning(a,b,index){
            let versionId = JSON.parse(localStorage.getItem('userInfo')).versionId
            this.$get(api.questionnaire.earlyWarning(versionId,a,b)).then(element=>{
                if(element.status == 1){
                    this.$set(this.list[index], 'obj', element.data)
                }
            })
        },
    },
    mounted() {
        this.getAllGradeRef1()
    },
}
</script>
<style lang="scss" scoped>
    .Capacity{
        .Capacity-dv{
            .Capacity-dvh{
                width: 100%;
                height: 318px;
                background: url('../../assets/bg-chengzhang03.png') no-repeat center center;
                background-size: 100% 100%;
                h1{
                    position: absolute;
                    right:  -60px; 
                    top: 160px; 
                    transform: translate(-50%, -50%);
                    font-size:40px;
                    font-family:PingFangSC;
                    font-weight:600;
                    color:rgba(255,255,255,1);
                    // letter-spacing: 5px;
                    display: block;
                }
                img{
                    width: 100%;
                    height: 318px;
                }
            }
        }
        .Capacity-dv1{
            width: 100%;
            position: absolute;
            top: 270px;
            padding: 0 24px;
            .hehe-enter,.hehe-leave-to{
                opacity: 0;
            }
            .hehe-enter-to,.hehe-start{
                opacity: 0.5;
            }
            .hehe-enter-start,.hehe-leave{
                opacity: 1;
            }
            .hehe-enter-active,.hehe-leave-active{
                transition: ease-in 0.2s;
            }
            ul{
                li{
                    list-style: none;
                    background:rgba(255,255,255,1);
                    box-shadow:$box-shadow;
                    border-radius:10px;
                    padding: 40px 30px;
                    margin-bottom: 30px;
                    .arrowshang{
                        float:right;
                        width:30px;
                        height:30px;
                        background: url('../../assets/arrow-shang.png') no-repeat center center;
                        background-size: 100% 100%; 
                        margin-top: 10px;
                    }
                    .arrowxia{
                        margin-top: 10px;
                        float:right;
                        width:30px;
                        height:30px;
                        background: url('../../assets/arrow-xia.png') no-repeat center center;
                        background-size: 100% 100%; 
                    }
                    .biaoti{
                        margin-top: 10px;
                        float:left;
                        width:45px;
                        height:25px;
                        margin-right: 15px;
                        background: url('../../assets/dian-biaoti3.png') no-repeat center center;
                        background-size: 100% 100%; 
                    }
                    span{
                        font-size:30px;
                        font-family:PingFangSC;
                        font-weight:700;
                        color:rgba(50,50,50,1);
                    }
                    .Capacity_content{
                        .className{
                            width:100%;
                            height: 500px;
                            margin-top: 50px;
                        }
                        h3{
                            font-size:30px;
                            font-family:PingFangSC;
                            font-weight:700;
                            color:#323232;
                            text-align: center;
                            margin-top: 50px;
                        }
                        h2{
                            font-size:20px;
                            font-family:PingFangSC;
                            font-weight:400;
                            color:rgba(150,150,150,1);
                            text-align: left;
                            margin-top: 20px;
                            margin-bottom: 50px;
                        }
                        .Capacity_fan{
                            .fan_ul{
                                margin-top: 30px;
                                .fan_li{
                                    list-style: none;  
                                    padding: 0;
                                    box-shadow: none;
                                    margin-bottom: 40px;
                                    .fan_dvfloat{
                                        .icontongguo{
                                            float:left;
                                            width:64px;
                                            height:64px;
                                            margin-right: 15px;
                                            background: url('../../assets/tongguo.png') no-repeat center center;
                                            background-size: 100% 100%; 
                                        }
                                        .iconzhuyi{
                                            float:left;
                                            width:64px;
                                            height:64px;
                                             margin-right: 15px;
                                            background: url('../../assets/zhuyi.png') no-repeat center center;
                                            background-size: 100% 100%; 
                                        }
                                        .iconyujing{
                                            float:left;
                                            width:64px;
                                            height:64px;
                                             margin-right: 15px;
                                            background: url('../../assets/yujing.png') no-repeat center center;
                                            background-size: 100% 100%; 
                                        }
                                    }
                                    // .fan_dvfloat1{
                                    //     display: flex;
                                    //     svg {
                                    //         width:150px;
                                    //         height:80px;
                                    //     }
                                    // }
                                    // .fan_dvfloat2{
                                    //     display: flex;
                                    //     svg {
                                    //         width:80px;
                                    //         height:80px;
                                    //     }
                                    // }
                                    // img{
                                    //     width:64px;
                                    //     height:64px;
                                    //     float: left;
                                    // }
                                    
                                    span{
                                        font-size:24px;
                                        font-family:PingFangSC;
                                        font-weight:500;
                                        margin-top: 15px;
                                        margin-left: 15px;
                                        letter-spacing: 3px;
                                        display: table;
                                    }
                                    .colorfont{
                                        color: $color-primary;
                                    } 
                                    .colorfont1{
                                        color: #FEC744;
                                    } 
                                    .colorfont2{
                                        color: #FD6162;
                                    } 
                                    p{
                                        font-size:20px;
                                        font-family:PingFangSC;
                                        font-weight:400;
                                        color:rgba(150,150,150,1);
                                        margin-top: 33px;
                                        line-height: 45px;
                                        text-align: left;
                                        letter-spacing: 2px;
                                    }
                                    .falont{
                                        margin-top: 35px;
                                        padding-left: 6px;
                                        .fan_dv1{
                                            padding: 16px 48px;
                                            background:rgba(244,244,244,1);
                                            border-radius:10px;
                                            display: inline-block;
                                            margin-right: 20px;
                                            font-size:24px;
                                            font-family:PingFangSC;
                                            font-weight:400;
                                            color:rgba(150,150,150,1);
                                            margin-bottom: 20px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
   
</style>